/* eslint-disable max-len */
import { Box, DialogContent, DialogTitle, Grid, Link, styled, Typography, useMediaQuery } from "@mui/material";
import { ScanMain } from "../components";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import ApiRoutes from "../../../config/api.routes";
import { useAxios } from "../../../services/http.service";
import { MainWidget, Widget, WidgetContainer, WidgetRow } from "../../Profile/Dashboard";
import { ActionBtn, AddressLink, CurrencyLabel, TableComponent, Text } from "../../../components";
import {
  EcoBankLandsSchema,
  MobileEcoBankLandsSchema,
  TransactionMobileSchema,
  TransactionsSchema,
} from "../../../utils/table-schemas";
import { PersonRounded, HealthAndSafety as VerifiedUser } from "@mui/icons-material";
import { formatLink, sizing } from "../../../utils/methods";
import ProfilePicture from "../../Profile/verification/profile-picture";
import { useTheme } from "@mui/material/styles";
import { DialogPopUp } from "../../../components/OrgPopUp";
import React from "react";
import { CURRENCY_NAME } from "../../../utils/constants";
import Waterfall from "../../../assets/waterfall-blog.jpg";


const TrustWallet = () => {
  const axios = useAxios();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(560));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const { address } = useParams();
  const [orgModalOpen, setOrgModalOpen] = useState(false);
  const [transactions, setTransactions] = useState(0);
  const [lands, setLands] = useState(0);

  const [trustData, setTrustData] = useState<any>(null);
  const [organizationData, setOrganizationData] = useState<any>(null);
  const [orgLands, setOrgLands] = useState<any>(null);

  const [activeTab, setActiveTab] = useState<"lands" | "transactions">("transactions");

  useEffect(() => {
    fetchData();
  }, [address]);

  const fetchData = async () => {
    try {
      const response = await axios.get(ApiRoutes.trust.wallet + `?address=${address}`).then((res) => res.data);

      if (response.landsCount) {
        setLands(response.landsCount);
      }
      if (response.trust) {
        setTrustData(response.trust);
      }
      if (response.organization) {
        setOrganizationData(response.organization);
      }
      if (response.createdAt) {
        // setJoinedDate(response.createdAt);
      }
      if (response.transactions) {
        setTransactions(response.transactions);
      }
      if (response.verifiedLands) {
        setOrgLands(response.verifiedLands);
      }
    } catch (e) {
      console.log("error", { e });
    }
  };

  return (
    <ScanMain style={{ width: "100%", height: "100%" }}>
      <WidgetRow
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          justifyContent: { xs: "start", md: "start" },
          borderBottom: 1,
          borderColor: "border.dark",
          backgroundColor: "back.darkGreen",
          flexDirection: { xs: "row-reverse", md: "row" },
        }}
      >
        <MainWidget
          sx={{
            border: 0,
            backgroundColor: "back.darkGreen",
            color: "back.purple",
            height: "100%",
            width: { xs: "100%" },
          }}
        >
          <Widget
            sx={{
              p: sizing(0),
              border: 0,
              backgroundColor: "unset",
              alignItems: "end",
              flex: "none",
              justifyContent: { xs: "start" },
              display: { xs: "flex", sm: "none" },
            }}
          >
            {trustData?.profilePicture ? <ProfilePicture user={trustData as any} /> : <ProfilePicturePlaceholder />}
          </Widget>

          {organizationData?.name && (
            <WidgetRow sx={{ mb: sizing(3), gap: "6px" }}>
              <Text large underline bold>
                {organizationData.name}
              </Text>
              <VerifiedUser />
            </WidgetRow>
          )}
          <Text numeric larger bold underline sx={{ mb: 3 }}>
            <AddressLink sx={{ "& a": { fontWeight: 600 } }} address={address as string} type={"plain"} copy long />
          </Text>

          {trustData?.name && (
            <Text medium sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              {trustData?.name} <LinksButton onClick={() => setOrgModalOpen(true)}> and more</LinksButton>            </Text>
          )}

          <div style={{ display: "none" }}>
            <SLink target="_blank" rel="noopener noreferrer" href={formatLink(organizationData?.website, true)}>
              {formatLink(organizationData?.website)}
            </SLink>
            <SLink target="_blank" rel="noopener noreferrer" href={`mailto:${organizationData?.email}`}>
              {organizationData?.email}
            </SLink>
          </div>
        </MainWidget>

        <Widget
          sx={{
            border: 0,
            backgroundColor: "back.darkGreen",
            display: { xs: "none", sm: "flex" },
            justifyContent: { xs: "start", sm: "end" },
            alignItems: { xs: "start", sm: "end" },
          }}
        >
          {trustData?.profilePicture ? <ProfilePicture user={trustData as any} /> : <ProfilePicturePlaceholder />}
        </Widget>
      </WidgetRow>
      <WidgetContainer sx={{ gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" } }}>
        <Widget sx={{ borderLeft: 0 }}>
          <WidgetRow>
            <Text large numeric>
              {lands}
            </Text>
          </WidgetRow>
          <WidgetRow>Lands verified</WidgetRow>
        </Widget>

        <Widget>
          <WidgetRow>
            <Text large>{organizationData?.country || "Loading..."}</Text>
          </WidgetRow>
          <WidgetRow>Active country</WidgetRow>
        </Widget>

        <Widget sx={{ borderRight: 0 }}>
          <WidgetRow>
            <Text large sx={{ width: "100%" }}>
              {orgLands && orgLands.length > 0 ? orgLands[0]?.name : "None"}
            </Text>
          </WidgetRow>
          <WidgetRow>Recently verified</WidgetRow>
        </Widget>
      </WidgetContainer>

      <TabsRow sx={{ p: sizing(6), pb: sizing(0) }}>
        <ActionBtn
          className={activeTab === "transactions" ? "active" : ""}
          variant={activeTab === "transactions" ? "contained" : "outlined"}
          size="small"
          onClick={() => setActiveTab("transactions")}
        >
          Transactions
        </ActionBtn>
        <ActionBtn
          className={activeTab === "lands" ? "active" : ""}
          variant={activeTab === "lands" ? "contained" : "outlined"}
          size="small"
          onClick={() => setActiveTab("lands")}
        >
          Lands
        </ActionBtn>
      </TabsRow>

      {activeTab === "lands" && (
        <TableComponent
          mobileTitle="Verified lands"
          batch={5}
          totalItems={lands}
          title="Verified lands"
          apiURL={ApiRoutes.ecoBank.lands.root + `?address=${address}&type=trust`}
          schema={isMobile ? MobileEcoBankLandsSchema : EcoBankLandsSchema}
        />
      )}

      {activeTab === "transactions" && (
        <TableComponent
          mobileTitle="Wallet transactions"
          batch={5}
          totalItems={transactions}
          title="Wallet transactions"
          apiURL={ApiRoutes.ecoBank.transactions.root + `?address=${address}&type=trust`}
          schema={isMobile ? TransactionMobileSchema : TransactionsSchema}
        />
      )}

      <DialogPopUp
        open={orgModalOpen}
        onClose={() => {
          setOrgModalOpen(false);
        }}
      >
        <DialogContent sx={{ p: 0, backgroundColor: "transparent" }}>
          <Grid
            container
            direction={'row'}
            alignItems="center"
            height={isSmallScreen ? '100%' : '300px'}
          >
            <Grid
              item
              xs={12}
              md={6}
              style={{
                borderBottomRightRadius: isSmallScreen ? "0px" : "16px",
              }}
              order={isSmallScreen ? 0 : 1} // Ensure the background image component is on top for small screens
              sx={{
                padding: "20px",
                backgroundImage: `url(${orgLands ? orgLands[0]?.image : Waterfall})`, // Optional: to set the background image
                backgroundColor: "white",
                backgroundSize: 'cover', // Optional: to cover the entire area
                backgroundPosition: 'center', // Optional: to center the image
                height: isSmallScreen ? '200px' : '300px',
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  zIndex: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"monospace"}
                    fontWeight={600}
                    color="white"
                  >
                    Recently Verified
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    fontFamily={"monospace"}
                    fontWeight={600}
                    color="white"
                    style={{ textDecoration: 'underline' }}
                  >
                    {orgLands ? orgLands[0]?.name : "No recent verifications"}
                  </Typography>
                </div>
                <Box sx={{ flexGrow: 1 }} />
              </Box>
            </Grid>
            <Grid
              item
              height={isSmallScreen ? '100%' : '300px'}
              xs={12}
              md={6}
              style={{
                borderBottomLeftRadius: "16px",
                backgroundColor: 'white',
                borderBottomRightRadius: isSmallScreen ? '16px' : '0px',
              }}
              order={isSmallScreen ? 1 : 0}
            >
              <Box
                sx={{
                  height: `${isSmallScreen ? '350px' : '300px'}`,
                  padding: "20px",
                  paddingLeft: "40px",
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <div>
                  <DialogTitle sx={{ padding: '0px', fontWeight: "600", color: "GrayText", fontSize: "14px" }} align="left">About</DialogTitle>
                  <DialogTitle sx={{ padding: '0px', fontWeight: "600" }} align="left">
                    {organizationData?.name}
                  </DialogTitle>
                  {/* <Box sx={{ marginBottom: 2 }}>
                    <Typography variant="subtitle1" color="text.primary">
                      {organizationData?.type}
                    </Typography>
                  </Box> */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    
                    <Typography variant="body2" color="text.disabled">
                      {organizationData?.website}
                    </Typography>
                    <Typography variant="body2" color="text.disabled">
                      {organizationData?.address}
                    </Typography>
                    {/* <Typography variant="body2" color="text.disabled">
                      {organizationData?.phone}
                    </Typography>
                    <Typography variant="body2" color="text.disabled">
                      {organizationData?.email}
                    </Typography> */}
                    
                  </Box>
                </div>
                {/* <Box sx={{ paddingTop: 2 }}>
                  <Typography variant="caption" color="text.disabled">
                    <a href={AppRoutes.About.path} target="_blank" rel="noopener noreferrer" style={{ marginRight: '4px' }}> Learn more</a> about how to become an EcoFutures Trustee
                  </Typography>
                </Box> */}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogContent sx={{ p: 0, backgroundColor: "transparent" }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              height: 'fit-content',
              backgroundColor: 'back.oliveGreen',
              borderTopLeftRadius: '16px',
              borderTopRightRadius: '16px',
            }}
          >
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                padding: '20px',
              }}
            >
              <div style={{ display: 'flex', justifyContent: "space-between", paddingBottom: "16px", borderBottom: "1px solid black" }}>
                <Typography>
                  Active Trustees
                </Typography>
                <Typography>
                  Portfolio
                </Typography>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '100px', overflowY: 'auto', paddingTop: '16px' }}>
                {organizationData?.secondaryWallets?.map((trustee: any) => (
                  trustee?.orgName === organizationData?.organization?.orgName && trustee?.trusteeStatus === 'verified' && (
                    <React.Fragment key={trustee?.email}>
                      <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '8px', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '8px' }}>
                          <AddressLink sx={{ fontSize: '14px' }} type="user" address={trustee?.address} links={false} />
                          {trustee?.name}
                        </Box>
                        <Typography>
                          {trustee?.trusteePortfolio?.portfolioSum ? trustee?.trusteePortfolio?.portfolioSum : 0} <CurrencyLabel currency={CURRENCY_NAME} />
                        </Typography>
                      </Box>
                    </React.Fragment>
                  )
                ))}
              </div>
            </Box>
          </Box>
        </DialogContent>
      </DialogPopUp>



    </ScanMain>
  );
};
export const LinksButton = styled("div")`
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`;

export const TabsRow = styled("div")`
  display: flex;
  gap: 12px;
  background-color: ${({ theme }) => theme.palette.back?.table};

  /* The V9 Figma sits the count bubble 6px past the pill's top-right corner.
     MUI's default anchor centres a 20px badge on that corner (+10/-10), which
     reads as detached and, in the tab strip, pushes the bubble hard against the
     scroll container's clip edge. Nudging top/right by 4px rather than
     overriding the transform keeps MUI's scale(0) hide-when-zero intact. */
  & .MuiBadge-badge {
    top: 4px;
    right: 4px;
  }

     & button {
    border: 1px solid ${({ theme }) => (theme.palette.mode === "dark" ? theme.palette.border.default : theme.palette.border.default)};
    // padding: 4px 8px;
    border-radius: 15px;
    text-transform: capitalize;
    // line-height: 1;

    &:disabled {
      background-color: ${({ theme }) => theme.palette.border.default};
      color: ${({ theme }) => theme.palette.text.primary};
     
      pointer-events: none;
    }
      &.MuiButton-contained {
      background-color: ${({ theme }) => theme.palette.border.default};
        color: ${({ theme }) => theme.palette.text.primary};
        }
  }
`;

export const ProfilePicturePlaceholder = () => {
  return (
    <ProfileWrap>
      <IconProfile  />
    </ProfileWrap>
  );
};
const ProfileWrap = styled("div")`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  // border: 1px solid black;

  svg {
    color: #494949;
    font-size: 80px;
  }

  @media (max-width: 992px) {
    width: 90px;
    height: 90px;

    svg {
      font-size: 50px;
    }
  }
`;

const IconProfile = styled(PersonRounded)``;

const SLink = styled(Link)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  color: black;

  &:hover {
    text-decoration: underline;
    color: black;
  }
`;
export default TrustWallet;
